import { render, staticRenderFns } from "./teamResults.vue?vue&type=template&id=5ae77845&scoped=true&"
import script from "./teamResults.vue?vue&type=script&lang=js&"
export * from "./teamResults.vue?vue&type=script&lang=js&"
import style0 from "./teamResults.vue?vue&type=style&index=0&id=5ae77845&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae77845",
  null
  
)

export default component.exports